import { orgtest } from "@/api/index";

const sceneOrder = ["voiceCall", "BuyTrainTickets", "bookHotel"];

const sceneDefinitions = {
  voiceCall: {
    introRoute: "voiceCallIndex",
    answers: ["A1", "A1", "D1", "D2", "A1", "C1", "A3", "C1"],
  },
  BuyTrainTickets: {
    introRoute: "BuyTrainTicketsIndex",
    answers: [
      "A1",
      "D2",
      "D2",
      "A1",
      "D2",
      "A1",
      "D2",
      "D2",
      "A2",
      "D2",
      "A2",
      "D2",
      "D2",
      "A1",
      "D1",
      "A1",
      "A1",
      "D2",
      "B3",
      "A1",
      "B3",
    ],
  },
  bookHotel: {
    introRoute: "bookHotelIndex",
    answers: [
      "B2",
      "A3",
      "A1",
      "A1",
      "D2",
      "A1",
      "D3",
      "D3",
      "D3",
      "A1",
      "D2",
      "A1",
      "A2",
      "D2",
      "A2",
      "D2",
      "A1",
      "B3",
      "A1",
      "B3",
    ],
  },
};

let evaluationContext = null;
let scenes = [];
let currentSceneIndex = -1;

function reset() {
  evaluationContext = null;
  scenes = [];
  currentSceneIndex = -1;
  delete window.__evaluationStartTimestamp;
}

function initialize(sceneQuestions, context) {
  if (!Array.isArray(sceneQuestions) || sceneQuestions.length === 0) {
    reset();
    return;
  }

  evaluationContext = {
    content: context.content || [],
    totalScore: context.totalScore || 0,
    deviceCode: context.deviceCode || "",
    testId: context.testId || "",
    testCode: context.testCode || "",
    orgId: context.orgId || 1,
    startTimestamp: context.startTimestamp || Date.now(),
  };

  scenes = sceneQuestions
    .slice(0, sceneOrder.length)
    .map((question, index) => {
      const type = sceneOrder[index];
      const definition = sceneDefinitions[type];
      return {
        type,
        question: { ...question },
        answers: definition ? definition.answers.slice() : [],
        introRoute: definition ? definition.introRoute : "",
        replies: [],
        startTimestamp: null,
        endTimestamp: null,
      };
    })
    .filter((item) => item.introRoute);

  currentSceneIndex = scenes.length > 0 ? 0 : -1;
}

function hasScenes() {
  return scenes.length > 0;
}

function getCurrentScene() {
  if (currentSceneIndex < 0 || currentSceneIndex >= scenes.length) {
    return null;
  }
  return scenes[currentSceneIndex];
}

function getCurrentIntroRoute() {
  const scene = getCurrentScene();
  return scene ? scene.introRoute : null;
}

function getQuestionProgress() {
  const scene = getCurrentScene();
  if (!scene) {
    return {
      current: 0,
      total: 0,
    };
  }

  const answeredCount = Array.isArray(evaluationContext?.content)
    ? evaluationContext.content.length
    : 0;
  const totalScenes = scenes.length;
  const fallbackTotal = answeredCount + totalScenes;

  let current = answeredCount + currentSceneIndex + 1;
  let total = fallbackTotal;

  const sort = Number(scene.question?.sort);
  if (!Number.isNaN(sort) && sort > 0) {
    current = sort;
  }

  const questionTotal = Number(
    scene.question?.total ??
      scene.question?.totalCount ??
      scene.question?.totalNum
  );
  if (!Number.isNaN(questionTotal) && questionTotal > 0) {
    total = questionTotal;
  }

  return {
    current,
    total,
  };
}

function recordSuccess() {
  const scene = getCurrentScene();
  if (!scene) return;

  if (!scene.startTimestamp) {
    scene.startTimestamp = Date.now();
  }

  const index = scene.replies.length;
  if (index >= scene.answers.length) {
    return;
  }
  const answerCode = scene.answers[index];
  scene.replies.push(answerCode);
}

function completeScene() {
  const scene = getCurrentScene();
  if (!scene) return null;

  scene.endTimestamp = Date.now();

  currentSceneIndex += 1;
  const nextScene = getCurrentScene();
  if (nextScene) {
    return nextScene.introRoute;
  }
  return null;
}

function buildSceneContent() {
  if (!evaluationContext) return evaluationContext?.content || [];
  const content = evaluationContext.content
    ? evaluationContext.content.slice()
    : [];

  scenes.forEach((scene, index) => {
    const answer = scene.answers;
    const reply = scene.replies;
    const validity =
      answer.length > 0 && reply.length === answer.length ? 1 : 0;
    // const title = scene.question?.title || `场景题${index + 1}`
    const title = null;
    const useTime = scene.startTimestamp
      ? Math.floor(
          ((scene.endTimestamp || Date.now()) - scene.startTimestamp) / 1000
        )
      : 0;

    content.push({
      title,
      sort: scene.question?.sort ?? 0,
      // optionId: scene.question?.optionId ?? null,
      optionId: null,
      optionType: "scene",
      dimCode: scene.question?.dimCode || "",
      answer,
      reply,
      validity,
      useTime,
    });
  });
  return content;
}

function getSubmissionPayload() {
  if (!evaluationContext) return null;
  console.log(buildSceneContent(), "提交的答案");

  const content = buildSceneContent();
  const successCount = content.filter((item) => item.validity === 1).length;
  const totalCount = content.length;
  const useTime = Math.floor(
    (Date.now() - evaluationContext.startTimestamp) / 1000
  );

  return {
    payload: {
      testId: evaluationContext.testId,
      orgId: evaluationContext.orgId,
      deviceCode: evaluationContext.deviceCode,
      testCode: evaluationContext.testCode,
      totalScore: evaluationContext.totalScore,
      useTime,
      content: JSON.stringify(content),
    },
    resultQuery: {
      totalScore: evaluationContext.totalScore,
      testCode: evaluationContext.testCode,
      useTime,
      successCount,
      totalCount,
    },
  };
}

async function submitResults() {
  const submission = getSubmissionPayload();
  if (!submission) return null;
  await orgtest(submission.payload);
  const { resultQuery } = submission;
  reset();
  return resultQuery;
}

export default {
  initialize,
  hasScenes,
  getCurrentIntroRoute,
  getQuestionProgress,
  recordSuccess,
  completeScene,
  getSubmissionPayload,
  submitResults,
  reset,
};
